import React from 'react'

const LogoutPopup = () => {
    return (
        <>
            <div className="modal fade" id="logout_modal" tabIndex={-1} aria-labelledby="LogoutModal" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="DownloadModalLabel">Confirmation Alert!</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <h5>Are you sure you want to logout?</h5>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                            <a href="auth-cover-signin" type="button" className="btn btn-primary">Logout</a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LogoutPopup